import find from "lodash/find";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import { Flex, Center, Box, Text } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import toaster from "toasted-notes";

import { wrapper } from "../../src/redux/store";
import TopBand from "../../src/components/common/topBand";

import Error from "../../src/components/common/error";
import ProductTabs from "../../src/components/products/productTabs";
import ProductOverView from "../../src/components/products/productOverView";
import ErrorToaster from "../../src/components/common/error/errorToaster";

import {
  fetchAllProducts,
  getActionsOfProduct,
  getImageData,
  getIngredientsOfProduct,
  getRelatedVideosOfProduct,
  getRelatedImageIds,
} from "../../src/services/products";
import { fetchProducts, fetchProductCategories } from "../../src/redux/actions";
import { fetchBlogsForTagSlug } from "../../src/services/blogService";
import { fetchYoutubeVideosByIds } from "../../src/services/youtubeVideos";
import { capitalizeFirstLetter } from "../../src/utils/functions";

import ProductVideoList from "../../src/components/products/productVideoList";
import RelatedImageList from "../../src/components/products/relatedImageList";

const BlogList = dynamic(() => import("../../src/components/blog/blogList"));

const VideoModal = dynamic(
  () => import("../../src/components/home/videoModal"),
  { ssr: false }
);

export default function ProductDetail({ product, errorMessage }) {
  if (errorMessage) {
    return <Error errorMessage={errorMessage} />;
  }

  const [actions, setActions] = useState([]);
  const [productBlogs, setProductBlogs] = useState([]);
  const [ingredients, setIngredients] = useState([]);
  const [productVideoIds, setProductVideoIds] = useState([]);
  const [relatedImages, setRelatedImages] = useState([]);
  const [productVideos, setProductVideos] = useState([]);

  const [activeVideo, setActiveVideo] = useState(null);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  const prepareIngedientsData = async (product) => {
    const ingredients = getIngredientsOfProduct(product);
    const actions = getActionsOfProduct(product);
    const productVideoIds = getRelatedVideosOfProduct(product);
    const relatedImageIds = getRelatedImageIds(product);

    for (const ingredient of ingredients) {
      const rawImageData = await getImageData(ingredient.image);
      ingredient["sourceUrl"] = rawImageData.sourceUrl;
    }

    const relatedImages = [];
    for (const relatedImageId of relatedImageIds) {
      const relatedImageData = await getImageData(relatedImageId);
      relatedImages.push(relatedImageData);
    }

    setActions([...actions]);
    setIngredients([...ingredients]);
    setProductVideoIds([...productVideoIds]);
    setRelatedImages([...relatedImages]);
  };

  const getRelatedBlogs = async (tagName) => {
    try {
      const response = await fetchBlogsForTagSlug(tagName);
      setProductBlogs(response);
    } catch (err) {
      toaster.notify(<ErrorToaster errorMessage={err.message} />, {
        duration: 3000,
        position: "top",
      });
    }
  };

  const getYoutubeVideos = async (productVideoIds) => {
    try {
      const response = await fetchYoutubeVideosByIds(productVideoIds);
      if (response.success && response.data) {
        setProductVideos(response.data);
      } else {
        toaster.notify(<ErrorToaster errorMessage={response.message} />, {
          duration: 3000,
          position: "top",
        });
      }
    } catch (err) {
      toaster.notify(<ErrorToaster errorMessage={err.message} />, {
        duration: 3000,
        position: "top",
      });
    }
  };

  const handleOpenVideoModal = (videoId) => {
    setActiveVideo(videoId);
    setIsVideoModalOpen(true);
  };
  const handleCloseVideoModal = () => {
    setActiveVideo(null);
    setIsVideoModalOpen(false);
  };

  useEffect(() => {
    getRelatedBlogs(product.name);
  }, []);

  useEffect(() => {
    getYoutubeVideos(productVideoIds);
  }, [productVideoIds]);

  useEffect(() => {
    prepareIngedientsData(product);
  }, [product]);

  const { cart } = useSelector((state) => state);
  const cartProductIds = cart.map((product) => product.id);

  return (
    <>
      <TopBand title="Product Details" />
      <Center flexDirection="column" mb="50px">
        <Flex
          mt="50px"
          width={{ base: "90%", "2xl": "1350px" }}
          flexDirection={{ base: "column", lg: "row" }}
          justifyContent={{ base: "space-between" }}
        >
          <ProductOverView
            actions={actions}
            product={product}
            cartProductIds={cartProductIds}
          />
        </Flex>
        {/* {productVideos && productVideos.length > 0 && (
          <Box mt="50px" width={{ base: "90%", "2xl": "1350px" }}>
            <Flex
              flexDirection={{ base: "column", lg: "row" }}
              justifyContent={{ base: "flex-start", lg: "space-between" }}
            >
              <Box>
                <Text
                  lineHeight="1"
                  color="titleColor"
                  variant="headingHomePage"
                >
                  Watch Videos and Reels on{" "}
                  {`${capitalizeFirstLetter(product.name)}`}
                </Text>
              </Box>
            </Flex>
            <ProductVideoList
              productVideos={productVideos}
              openVideoModal={handleOpenVideoModal}
            />
          </Box>
        )}
        {relatedImages && relatedImages.length > 0 && (
          <Box mt="50px" width={{ base: "90%", "2xl": "1350px" }}>
            <Flex
              flexDirection={{ base: "column", lg: "row" }}
              justifyContent={{ base: "flex-start", lg: "space-between" }}
            >
              <Box>
                <Text
                  lineHeight="1"
                  color="titleColor"
                  variant="headingHomePage"
                >
                  {`${capitalizeFirstLetter(product.name)} gallery`}
                </Text>
              </Box>
            </Flex>
            <RelatedImageList relatedImages={relatedImages} />
          </Box>
        )} */}
        <ProductTabs product={product} ingredients={ingredients} />
        {/* {productBlogs && productBlogs.length > 0 && (
          <Box mt="10" mb="5" width={{ base: "90%", "2xl": "1350px" }}>
            <Flex
              flexDirection={{ base: "column", lg: "row" }}
              justifyContent={{ base: "flex-start", lg: "space-between" }}
            >
              <Box>
                <Text
                  lineHeight="1"
                  color="titleColor"
                  variant="headingHomePage"
                >
                  Related Blogs
                </Text>
              </Box>
            </Flex>
            <BlogList blogs={productBlogs} />
          </Box>
        )} */}
      </Center>
      {/* <VideoModal
        videoId={activeVideo}
        activeVideo={activeVideo}
        isVideoModalOpen={isVideoModalOpen}
        closeVideoModal={handleCloseVideoModal}
      /> */}
    </>
  );
}

export const getStaticProps = wrapper.getStaticProps(
  (store) =>
    async ({ params }) => {
      const { slug } = params;
      try {
        await store.dispatch(fetchProductCategories());
        const products = await store.dispatch(fetchProducts());

        const product = find(products, { slug });

        return {
          props: { product },
        };
      } catch (err) {
        return {
          props: {
            product: [],
            errorMessage: err.message,
          },
        };
      }
    }
);

export async function getStaticPaths() {
  try {
    const products = await fetchAllProducts();
    const paths = products.map(({ id, slug }) => ({
      params: { slug },
    }));

    return {
      paths,
      fallback: false,
    };
  } catch (err) {
    console.log(err);
    return { paths: [], fallback: false };
  }
}
